<script>
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/Permissions/Applications/table-headers'

import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePermissionApplications',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
